var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagnifyingGlass = props => {
  props = {
    ...props,
    style: {
      display: 'inline-block',
      width: '1em',
      height: '1em',
      maxWidth: '100%',
      maxHeight: '100%',
      fill: 'currentColor',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: 0,
      ...props.style
    }
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.003 32.005c.27 0 .509-.104.717-.313a.956.956 0 0 0 .28-.703.956.956 0 0 0-.28-.703l-9.69-9.783a12.987 12.987 0 0 0 2.118-3.672c.52-1.365.779-2.808.779-4.33 0-1.729-.327-3.354-.982-4.875a12.496 12.496 0 0 0-2.68-3.97A12.774 12.774 0 0 0 17.294.986 12.028 12.028 0 0 0 12.463 0C10.74 0 9.12.328 7.603.985A12.774 12.774 0 0 0 3.63 3.657a12.286 12.286 0 0 0-2.664 3.97C.322 9.146 0 10.771 0 12.501s.322 3.355.966 4.876a12.286 12.286 0 0 0 2.664 3.969 12.774 12.774 0 0 0 3.973 2.672c1.516.657 3.136.985 4.86.985 1.558 0 3.033-.271 4.425-.813a12.615 12.615 0 0 0 3.74-2.25l9.658 9.751a.984.984 0 0 0 .717.313Zm-18.54-8.97c-1.454 0-2.82-.276-4.097-.828a10.457 10.457 0 0 1-3.334-2.266 10.864 10.864 0 0 1-2.243-3.345c-.55-1.27-.826-2.636-.826-4.094 0-1.459.275-2.823.826-4.094a10.864 10.864 0 0 1 2.243-3.345 10.457 10.457 0 0 1 3.334-2.266 10.216 10.216 0 0 1 4.097-.828c1.434 0 2.79.276 4.067.828a10.457 10.457 0 0 1 3.334 2.266 10.864 10.864 0 0 1 2.243 3.345c.55 1.27.826 2.635.826 4.094 0 1.458-.275 2.823-.826 4.094a10.864 10.864 0 0 1-2.243 3.345 10.457 10.457 0 0 1-3.334 2.266 10.139 10.139 0 0 1-4.067.828Z"
  })));
};
export default SvgMagnifyingGlass;